import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

import SubUsers from 'pages/Profile/SubUsers';
import PermissionSubUsers from 'pages/Profile/PermissionSubUser';
import ProfileDebitors from 'pages/Profile/Debitors';
import ProfileCreditors from 'pages/Profile/Creditors';
import Profile from 'pages/Profile';
import ProfileDetails from 'pages/Profile/Details';
import ProfilePassword from 'pages/Profile/Password';
import JobNumbers from 'pages/Profile/JobNumbers';
import ProfileBanks from 'pages/Profile/Banks';
import ProfilePayment from 'pages/Profile/Payment';
import ProfileManagers from 'pages/Profile/Managers';
import { SubUserEdit } from 'pages/Profile/SubUserEdit';

import PrivateRoute from '../hoc/PrivateRoute';

export const profileRoutes: RouteObject[] = [
  {
    path: '/profile',
    element: (
      <PrivateRoute>
        <Profile />
      </PrivateRoute>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="details" />,
      },
      {
        path: 'details',
        element: <ProfileDetails />,
      },
      {
        path: 'password',
        element: <ProfilePassword />,
      },
      {
        path: 'debitors',
        element: <ProfileDebitors />,
      },
      {
        path: 'creditors',
        element: <ProfileCreditors />,
      },
      {
        path: 'managers',
        element: <ProfileManagers />,
      },
      {
        path: 'job-numbers',
        element: <JobNumbers />,
      },
      {
        path: 'bank',
        element: <ProfileBanks />,
      },
      {
        path: 'payment',
        element: <ProfilePayment />,
      },
      {
        path: 'subuser',
        element: <SubUsers />,
      },
      {
        path: 'subuser/addEdit',
        element: <SubUserEdit />,
      },
      {
        path: 'permission-sub-user/:id',
        element: <PermissionSubUsers />,
      },
    ],
  },
];
